import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@collaborate-health/uikit'

import UserQualificationsGrid from '../UserQualificationsGrid'
import { Scope } from '../../enums'

export interface UserQualificationsDialogProps {
  open: boolean
  scope?: Scope
  user?: {
    Id: number
    IdentityGuid: string
  } | null
  onClose: () => void
}

const UserQualificationsDialog = ({ open, scope = Scope.Tenant, user, onClose }: UserQualificationsDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth='lg'
      height='70vh'
      TransitionProps={{ unmountOnExit: true }}
    >
      <DialogTitle>User qualifications</DialogTitle>

      <DialogContent>
        <UserQualificationsGrid simpleView user={user} scope={scope} />
      </DialogContent>

      <DialogActions>
        <Button color='primary' onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default UserQualificationsDialog

